module.exports = __webpack_public_path__ + "static/media/17e-04_ST-2017-305x610cm-oleo-sobre-madera.0d218287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17e/17e-04_ST-2017-305x610cm-oleo-sobre-madera.jpg
// module id = 217
// module chunks = 0